module.exports = __webpack_public_path__ + "static/how-to-use-1-f0971177b0716e158a4493ceecb5e6d9.png";